<!-- Start 404 Error -->
<div class="error-area ptb-100">
    <div class="error-content">
        <h2>Refreshing.....</h2>
    </div>
</div>
<!-- End 404 Error -->